import { render, staticRenderFns } from "./MarkPrice.vue?vue&type=template&id=0f16d25b&"
import script from "./MarkPrice.vue?vue&type=script&lang=js&"
export * from "./MarkPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports